import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const IsGuvenligiUzmaniPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'İş Güvenliği Uzmanı | Adana OSGB Mersin Hatay Osmaniye | ASSA';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana iş güvenliği uzmanı, Mersin iş güvenliği uzmanı, Hatay iş güvenliği uzmanı, Osmaniye iş güvenliği uzmanı hizmetleri. Risk analizi, mevzuat uyumu, KKD yönetimi. ASSA OSGB profesyonel destek.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana iş güvenliği uzmanı, Mersin iş güvenliği uzmanı, Hatay iş güvenliği uzmanı, Osmaniye iş güvenliği uzmanı, OSGB iş güvenliği, İSG uzmanı');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/osgb/is-guvenligi-uzmani');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "İş Güvenliği Uzmanı Hizmetleri",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde profesyonel iş güvenliği uzmanı hizmetleri. Risk analizi, mevzuat uyumu, KKD yönetimi.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "telephone": "+90-850-346-2772",
        "email": "assa@assaisg.com"
      },
      "areaServed": [
        {"@type": "City", "name": "Adana"},
        {"@type": "City", "name": "Mersin"},
        {"@type": "City", "name": "Hatay"},
        {"@type": "City", "name": "Osmaniye"}
      ],
      "serviceType": "İş Güvenliği Uzmanı",
      "url": "https://www.assaosgb.com.tr/osgb/is-guvenligi-uzmani"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              İş Güvenliği Uzmanı Hizmetleri
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde iş güvenliği uzmanı hizmetleri sunuyoruz. İşyerinizde güvenli çalışma ortamı oluşturmak için uzman kadromuzla yanınızdayız.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              İş Güvenliği Uzmanı Hizmetlerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service Card 1 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Risk Analizi</h3>
                <p className="text-gray-600">
                  İşyeri risk değerlendirmesi ve tehlike analizi. <strong>Adana iş güvenliği uzmanı</strong> hizmetlerimizle güvenli çalışma ortamı sağlıyoruz.
                </p>
              </div>

              {/* Service Card 2 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-shield-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Mevzuat Uyumu</h3>
                <p className="text-gray-600">
                  İş sağlığı ve güvenliği mevzuatına uyum sağlama. <strong>Mersin OSGB iş güvenliği uzmanı</strong> olarak yasal yükümlülüklerinizi yerine getiriyoruz.
                </p>
              </div>

              {/* Service Card 3 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-hard-hat-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">KKD Yönetimi</h3>
                <p className="text-gray-600">
                  Kişisel koruyucu donanım seçimi ve kullanım takibi. <strong>Hatay OSGB</strong> bölgesinde profesyonel destek sunuyoruz.
                </p>
              </div>

              {/* Service Card 4 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-alarm-warning-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Acil Durum Planları</h3>
                <p className="text-gray-600">
                  Acil durum eylem planlarının hazırlanması ve uygulanması. <strong>Osmaniye iş güvenliği uzmanı</strong> hizmetlerimizle güvende olun.
                </p>
              </div>

              {/* Service Card 5 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-search-eye-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İşyeri Denetimleri</h3>
                <p className="text-gray-600">
                  Düzenli işyeri güvenlik denetimleri ve raporlama. <strong>Adana OSGB</strong> standartlarında hizmet veriyoruz.
                </p>
              </div>

              {/* Service Card 6 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-book-open-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Eğitim Koordinasyonu</h3>
                <p className="text-gray-600">
                  İSG eğitimlerinin planlanması ve koordinasyonu. <strong>Mersin iş güvenliği uzmanı</strong> olarak eğitim desteği sağlıyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Hizmet Bölgelerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adana OSGB</h3>
                <p className="text-gray-600">
                  Adana ve çevresinde <strong>iş güvenliği uzmanı</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Mersin OSGB</h3>
                <p className="text-gray-600">
                  Mersin bölgesinde profesyonel <strong>iş güvenliği uzmanı</strong> desteği
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hatay OSGB</h3>
                <p className="text-gray-600">
                  Hatay'da güvenilir <strong>iş güvenliği uzmanı</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Osmaniye OSGB</h3>
                <p className="text-gray-600">
                  Osmaniye'de uzman <strong>iş güvenliği uzmanı</strong> kadrosu
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              İş Güvenliği Uzmanı Hizmeti Almak İster misiniz?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde profesyonel iş güvenliği uzmanı hizmetleri için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim" 
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                Hemen İletişime Geçin
              </Link>
              <a 
                href="tel:08503462772" 
                className="bg-blue-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-blue-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                0850 346 2772
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IsGuvenligiUzmaniPage;
